import { render, staticRenderFns } from "./FieldSetComponent.vue?vue&type=template&id=5966883a&scoped=true&"
import script from "./FieldSetComponent.vue?vue&type=script&lang=js&"
export * from "./FieldSetComponent.vue?vue&type=script&lang=js&"
import style0 from "./FieldSetComponent.vue?vue&type=style&index=0&id=5966883a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5966883a",
  null
  
)

export default component.exports